import React from 'react';

import { useGraphql } from '@sbu/contexts.graphql';

import { useEntityCriticalities } from 'app/Entities';
import { useCustomEntityTypes } from 'app/Entities/queries';
import {
  entityDefaultFields,
  entityDefaultSuggestions,
  ListField,
  SearchFilter,
} from 'shared/components/internal/Filter';

interface EntitiesSearchFilterProps {
  filterLabel?: string;
  queryString: string;
  onQueryChange: (query: string) => void;
}

export const EntitiesSearchFilter = ({
  filterLabel,
  queryString,
  onQueryChange,
}: EntitiesSearchFilterProps) => {
  const { data, loading } = useCustomEntityTypes();
  const { data: criticalityValues } = useEntityCriticalities();
  const graphqlContext = useGraphql();

  const getEntitySearchFilterFields = () => {
    const defaultFields = entityDefaultFields(
      graphqlContext,
      criticalityValues?.entityCriticalityConfigs?.objects || []
    );

    if (loading) {
      return defaultFields;
    }

    const customEntityTypes = data?.customEntityTypes?.objects?.map((obj) => ({
      prop: obj.identifier,
      label: obj.name,
    }));

    const typeIndex = defaultFields.findIndex((field) => field.prop === 'type');

    if (typeIndex >= 0) {
      (defaultFields[typeIndex] as ListField).options = [
        ...((defaultFields[typeIndex] as ListField).options || []),
        ...(customEntityTypes || []),
      ];
    }

    return defaultFields;
  };

  return (
    <SearchFilter
      activeSource='entity'
      dslString={queryString}
      filterLabel={filterLabel}
      fields={getEntitySearchFilterFields()}
      onQueryStringChange={onQueryChange}
      suggestedFilters={entityDefaultSuggestions()}
      variant='compact'
    />
  );
};
